import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { useLayoutEffect } from 'react';
import endereco from '../cliente/endereco/endereco';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PEDIDO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PEDIDO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'PEDIDO_SET_FILTRO',
        payload: filtro
    };
}

export function setDialogCodigoSM(registro) {
    return {
        type: 'PEDIDO_SET_DIALOG_SM',
        payload: registro
    };
}

export function initForm(registro = {}, recalculo = false) {

    if (recalculo) {
        registro = {
            ...registro,
            itens: (registro.itens || []).map(item => {

                let prazo = parseFloat(FormatUtils.formatarValorBanco(item.prazo, 0) || 0);
                let quantidade = parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
                let precoBasePrazo = parseFloat(item.preco_base_prazo || 0);
                let precoUnitarioBase = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4));
                let precoUnitario = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario, 4));
                let precoPrazo = precoUnitarioBase + precoBasePrazo;
                let total = precoUnitario * quantidade;

                return {
                    ...item,
                    preco_unitario: FormatUtils.formatarValorTela(precoUnitario, 4),
                    preco_base_prazo: precoBasePrazo,
                    preco_prazo: FormatUtils.formatarValorTela(precoPrazo, 4),
                    valor_total: FormatUtils.formatarValorTela(total, 2)
                }
            })
        }
    }

    return [
        initialize('pedidoForm', registro)
    ];
}

export function initFormAtualizaPreco(registro) {

    return (dispatch, getState) => {

        let listaPoliticaPreco = getState().pedido.listaPoliticaPreco;
        let listaUnidade = getState().pedido.listaUnidade;
        let listaDistribuidora = getState().pedido.listaDistribuidora;

        //1 - OLEO DIESEL B S10 ADITIVA
        let politicaS10 = listaPoliticaPreco.filter(item => item.id_unidade == registro.id_unidade && item.id_produto == 1)[0];
        let distribuidoraS10 = politicaS10 ? listaDistribuidora.filter(item => item.id == politicaS10.id_distribuidora)[0] : null;

        //3 - OLEO DIESEL B S500 ADITIVADO
        let politicaS500 = listaPoliticaPreco.filter(item => item.id_unidade == registro.id_unidade && item.id_produto == 3)[0];
        let distribuidoraS500 = politicaS500 ? listaDistribuidora.filter(item => item.id == politicaS500.id_distribuidora)[0] : null;
        
        let itens = (registro.itens || []).filter(item => item.ativo).map((item, i) => {

            if (registro.id_status != 1) {
                return item;
            } else {            
                let politicaSelecionada = listaPoliticaPreco.filter(politica => 
                    politica.id_unidade == registro.id_unidade
                    && politica.id_produto == item.id_produto)[0];

                let precoBasePrazo = parseFloat(item.preco_base_prazo || 0);
                let precoUnitarioBase = politicaSelecionada ? parseFloat(politicaSelecionada.preco) - parseFloat(politicaSelecionada.preco_frete) : 0;
                let precoPrazo = precoUnitarioBase + precoBasePrazo;
                    
                return {
                    ...item,
                    preco_unitario_bruto: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_bruto, 4) : null,
                    preco_unitario_base: FormatUtils.formatarValorTela(precoUnitarioBase, 4),
                    preco_unitario_frete: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_frete, 4) : null,
                    preco_prazo: FormatUtils.formatarValorTela(precoPrazo, 4)
                };
            }
        });

        registro = {
            ...registro,
            id_distribuidora_s10: distribuidoraS10 ? distribuidoraS10.id : null,
            id_distribuidora_s500: distribuidoraS500 ? distribuidoraS500.id : null,
            custo_operacao: listaUnidade.filter(item => item.id == registro.id_unidade)[0] ? listaUnidade.filter(item => item.id == registro.id_unidade)[0].custo_operacao || 0 : 0,
            itens: itens
        }
        
        dispatch(initForm(registro));
        dispatch(setModoTela('cadastro', registro));
        dispatch(salvar(registro, true));
    };

}

export function setFormPedido(tela, acao, registro) {

    return async (dispatch, getState) => {

        dispatch(setAguardando(true));

        await axios.get(`${consts.API_URL}/pedido?carregarRegistro=true&id=${registro.id}`).then(resp => {

            const registroCarregado = resp.data[0];
            
            if (registroCarregado) {

                //Se está digitando atualiza o preço
                if (tela == 'pedido' && acao == 'cadastro' && registroCarregado.id_status == 1) {                    
                    dispatch(initFormAtualizaPreco({
                        ...registroCarregado,
                        itens: (registroCarregado.itens || []).map(pedidoItem => ({
                            ...pedidoItem,
                            quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
                            preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
                            preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
                            preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
                            preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
                            preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
                            valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
                            data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
                            datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
                        }))
                    }));
                } else {
                    dispatch(initForm({
                        ...registroCarregado,
                        itens: (registroCarregado.itens || []).map(pedidoItem => ({
                            ...pedidoItem,
                            quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
                            preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
                            preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
                            preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
                            preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
                            preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
                            valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
                            data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
                            datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
                        }))
                    }));
                    dispatch(setModoTela(acao, {
                        ...registroCarregado,
                        itens: (registroCarregado.itens || []).map(pedidoItem => ({
                            ...pedidoItem,
                            quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
                            preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
                            preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
                            preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
                            preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
                            preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
                            valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
                            data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
                            datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
                        }))
                    }));
                }
            }

            dispatch(setAguardando(false));

        }).catch(e => {
            dispatch(setAguardando(false));
            console.log(e);
            
            setErroAPI(e);
        });
    }
}

export function getLista() {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?aberto=true`).then(resp => {
            dispatch({
                type: 'PEDIDO_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaLogistica() {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?logistica=true`).then(resp => {
            dispatch({
                type: 'PEDIDO_LOGISTICA_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaFinalizado(dataInicial, dataFinal) {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?finalizado=true${dataInicial ? `&data_inicial=${DateFormat.formatarDataTelaParaParametro(dataInicial)}` : ''}${dataFinal ? `&data_final=${DateFormat.formatarDataTelaParaParametro(dataFinal)}` : ''}`).then(resp => {
            dispatch({
                type: 'PEDIDO_FINALIZADO_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaEntrega(dataInicial, dataFinal) {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?apenasEntrega=true${dataInicial ? `&data_inicial=${DateFormat.formatarDataTelaParaParametro(dataInicial)}` : ''}${dataFinal ? `&data_final=${DateFormat.formatarDataTelaParaParametro(dataFinal)}` : ''}`).then(resp => {
            dispatch({
                type: 'PEDIDO_ENTREGA_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaEstoque(dataInicial, dataFinal) {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido/estoque?${dataInicial ? `&data_inicial=${DateFormat.formatarDataTelaParaParametro(dataInicial)}` : ''}${dataFinal ? `&data_final=${DateFormat.formatarDataTelaParaParametro(dataFinal)}` : ''}`).then(resp => {
            dispatch({
                type: 'PEDIDO_ESTOQUE_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaAnalise(dataInicial, dataFinal) {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido/analise?${dataInicial ? `&data_inicial=${DateFormat.formatarDataTelaParaParametro(dataInicial)}` : ''}${dataFinal ? `&data_final=${DateFormat.formatarDataTelaParaParametro(dataFinal)}` : ''}`).then(resp => {
            dispatch({
                type: 'PEDIDO_ANALISE_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function carregarEndereco(id) {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        
        dispatch({
            type: 'PEDIDO_ENDERECO_CARREGADO_LISTADO',
            payload: {
                data: []
            }
        });

        axios.get(`${consts.API_URL}/endereco/carregar?id=${id}`).then(resp => {
            dispatch({
                type: 'PEDIDO_ENDERECO_CARREGADO_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function salvar(registro, manterTela = false) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/pedido`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id,
				itens: (registro.itens || []).map(item => ({
					...item,
					quantidade: FormatUtils.formatarValorBanco(item.quantidade, 2),
                    preco_unitario_bruto: FormatUtils.formatarValorBanco(item.preco_unitario_bruto, 4),
                    preco_unitario_base: FormatUtils.formatarValorBanco(item.preco_unitario_base, 4),
                    preco_unitario_frete: FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4),
					preco_unitario: FormatUtils.formatarValorBanco(item.preco_unitario, 4),
                    preco_prazo: FormatUtils.formatarValorBanco(item.preco_prazo, 4),
                    valor_total: FormatUtils.formatarValorBanco(item.valor_total, 2),
                    data_emissao_nfe: DateFormat.formatarDataTelaParaSql(item.data_emissao_nfe),
                    datahora_previsao_entrega: DateFormat.formatarDataHoraTelaParaSql(item.datahora_previsao_entrega)
				}))
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
                dispatch(getListaLogistica());
                dispatch(getListaFinalizado(
                    DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 2592000000)),
                    DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
                ));
                if (registro.whatsapp_entrega_editado) {
                    dispatch(getListaEndereco());
                }
                dispatch(setModoTela('lista'));
                dispatch(setAguardando(false));
			}).catch(e => {
                setErroAPI(e);
                dispatch(setAguardando(false));
			});
		} else {
			axios.put(`${consts.API_URL}/pedido`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
                codigo_sm_entrega: parseInt(FormatUtils.formatarValorBanco(registro.codigo_sm_entrega, 0)) || null,
                codigo_sm_retorno: parseInt(FormatUtils.formatarValorBanco(registro.codigo_sm_retorno, 0)) || null,                
				itens: (registro.itens || []).map(item => ({
					...item,
                    quantidade: FormatUtils.formatarValorBanco(item.quantidade, 2),
                    preco_unitario_bruto: FormatUtils.formatarValorBanco(item.preco_unitario_bruto, 4),
                    preco_unitario_base: FormatUtils.formatarValorBanco(item.preco_unitario_base, 4),
                    preco_unitario_frete: FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4),
					preco_unitario: FormatUtils.formatarValorBanco(item.preco_unitario, 4),
                    preco_prazo: FormatUtils.formatarValorBanco(item.preco_prazo, 4),
                    valor_total: FormatUtils.formatarValorBanco(item.valor_total, 2),
                    data_emissao_nfe: DateFormat.formatarDataTelaParaSql(item.data_emissao_nfe),
                    datahora_previsao_entrega: DateFormat.formatarDataHoraTelaParaSql(item.datahora_previsao_entrega)
				}))
			}).then(resp => {                
                if (!manterTela) {
                    setSuccess('Operação Realizada com sucesso.');
                }
                if (!manterTela) {
                    dispatch(setModoTela('lista'));
                } else {
                    dispatch(initForm({
                        ...registro,
                        itens: (registro.itens || []).map(item => {
                            let itemIncluido = (resp.data.itensIncluidos || []).filter(itemAux => itemAux.idAux == item.idAux)[0];

                            if (itemIncluido) {
                                return {
                                    ...item,
                                    id: itemIncluido.id,
                                    id_pedido: registro.id
                                };
                            } else {
                                return item;
                            }
                        })
                    }));
                }
                setTimeout(() => {
                    dispatch(setAguardando(false));
                    dispatch(getLista());
                    dispatch(getListaLogistica());
                    dispatch(getListaFinalizado(
                        DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 2592000000)),
                        DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
                    ));
                    if (registro.whatsapp_entrega_editado) {
                        dispatch(getListaEndereco());
                    }
                }, 2000);
			}).catch(e => {
                setErroAPI(e);
                dispatch(setAguardando(false));
			});
		}
    };
}

export function salvarCodigoSM(registro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedido/codigoSM`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaEntrega());
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedido?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function imprimir(registro, agrupar = false) {
    return (dispatch, getState) => {

        let unidade = [
            { id : 1, nome: 'ÁGUA BOA', cnpj: '15.024.193/0007-83', ie: '13.880.354-4', endereco: 'Av. Industrial, Nº 66, Bairro Industrial I \n Água Boa / MT - CEP: 78635-000' },
            { id : 3, nome: 'BARRA DO GARÇAS', cnpj: '15.024.193/0005-11', ie: '13.708.774-8', endereco: 'Rua 10 0 Quadraind 1/3 Lote 1, Distrito Industrial \n Barra do Garças / MT - CEP 78605-778' },
            { id : 9, nome: 'PORTO ALEGRE DO NORTE', cnpj: '15.024.193/0006-00', ie: '13.880.368-4', endereco: 'Av. Dionel Martins de Almeida, SN, Zona Rural \n Porto Alegre do Norte / MT - CEP 78655-000' },
            { id : 60, nome: 'RIO VERDE (SERTÃO)', cnpj: '01.543.070/0001-59', ie: '10.292.576-3', endereco: 'AV JACOB OLIVAR ALIEV (ANTIGA GLEBA 10), SN - QUADRAGLEB 09 LOTE LT B - ZONA INDUSTRIAL\n Rio Verde / DO - CEP 75901-970' }
        ].filter(item => item.id == registro.id_unidade)[0];

        if (agrupar) {

            const itens = registro.itens || [];
            const produtosEspeciais = [1, 3];

            /*
            * Cria os grupos por cliente:
            *
            * - ESPECIAL: produtos 1 e 3
            * - OUTROS: qualquer outro produto
            */
            let grupos = [];

            itens.forEach(item => {

                if (!item.id_cliente) {
                    return;
                }

                const tipoGrupo =
                    produtosEspeciais.includes(Number(item.id_produto))
                        ? 'ESPECIAL'
                        : 'OUTROS';

                const grupoExistente =
                    grupos.find(grupo =>
                        grupo.id_cliente == item.id_cliente &&
                        grupo.tipo == tipoGrupo
                    );

                if (!grupoExistente) {
                    grupos.push({
                        id_cliente: item.id_cliente,
                        tipo: tipoGrupo
                    });
                }
            });

            for (let i = 0; i < grupos.length; i++) {

                const grupo = grupos[i];

                const idCliente =
                    grupo.id_cliente;

                const tipoGrupo =
                    grupo.tipo;

                /*
                * Primeiro filtra pelo cliente.
                *
                * Depois separa:
                *
                * ESPECIAL = produtos 1 e 3
                * OUTROS   = demais produtos
                */
                const itensFiltrados = itens
                    .filter(item => {

                        if (item.id_cliente != idCliente) {
                            return false;
                        }

                        const produtoEspecial =
                            produtosEspeciais.includes(
                                Number(item.id_produto)
                            );

                        if (tipoGrupo == 'ESPECIAL') {
                            return produtoEspecial;
                        }

                        return !produtoEspecial;
                    });

                const nomeUnidadePosto = null;
                const cnpjUnidadePosto = null;
                itensFiltrados.forEach(item => {
                    if (item.cnpj_posto) {
                        nomeUnidadePosto = item.cnpj_posto ? (item.cnpj_posto.split('|')[0] || '').trim() : null;
                        cnpjUnidadePosto = item.cnpj_posto ? (item.cnpj_posto.split('|')[1] || '').trim() : null;
                    }
                });

                let registroEnviar = {
                    ...registro,

                    posicao: i,

                    unidade_nome: nomeUnidadePosto || (unidade ? unidade.nome : null),
                    unidade_cnpj: cnpjUnidadePosto || (unidade ? unidade.cnpj : null),
                    unidade_ie: cnpjUnidadePosto ? '' : (unidade ? unidade.ie : null),
                    unidade_endereco: cnpjUnidadePosto ? '': (unidade ? unidade.endereco : null),

                    data_pedido:
                        registro.data_pedido
                            ? DateFormat.formatarDataSqlParaTela(
                                registro.data_pedido
                            )
                            : DateFormat.formatarDataSqlParaTela(
                                DateFormat.getDataAtual()
                            ),

                    nome_usuario_inclusao:
                        registro.nome_usuario_inclusao ||
                        getState().auth.usuario.nome,

                    itens: itensFiltrados
                        .map(item => {

                            let cliente =
                                getState().pedido.listaCliente
                                    .filter(itemCliente =>
                                        item.id_cliente == itemCliente.id
                                    )[0];

                            let endereco =
                                getState().pedido.listaEndereco
                                    .filter(itemEndereco =>
                                        item.id_endereco == itemEndereco.id
                                    )[0];

                            let produto =
                                getState().pedido.listaProduto
                                    .filter(itemProduto =>
                                        item.id_produto == itemProduto.id
                                    )[0];

                            let pedidoPrazo =
                                getState().pedidoPrazo.listaSelect
                                    .filter(itemPrazo =>
                                        item.id_prazo == itemPrazo.id
                                    )[0];

                            return {
                                ...item,
                                nome_cliente: cliente ? cliente.valor : '',
                                nome_endereco: endereco ? endereco.valor : '',
                                nome_produto: produto ? produto.valor : '',
                                prazo: pedidoPrazo ? pedidoPrazo.nome : item.prazo
                            };
                        })
                };

                axios.post(
                    `${consts.API_URL}/pedido/imprimir`,
                    registroEnviar
                )
                .then(resp => {

                    window.open(
                        `${consts.URL}/${resp.data}`,
                        '_blank'
                    );

                })
                .catch(e => {

                    setErroAPI(e);

                });
            }
        } else {

            const itens = registro.itens || [];
            const produtosEspeciais = [1, 3];

            /*
            * Cria os grupos por endereço:
            *
            * - ESPECIAL: produtos 1 e 3
            * - OUTROS: qualquer outro produto
            */
            let grupos = [];

            itens.forEach(item => {

                if (!item.id_endereco) {
                    return;
                }

                const tipoGrupo =
                    produtosEspeciais.includes(Number(item.id_produto))
                        ? 'ESPECIAL'
                        : 'OUTROS';

                const grupoExistente =
                    grupos.find(grupo =>
                        grupo.id_endereco == item.id_endereco &&
                        grupo.tipo == tipoGrupo
                    );

                if (!grupoExistente) {
                    grupos.push({
                        id_endereco: item.id_endereco,
                        tipo: tipoGrupo
                    });
                }
            });

            for (let i = 0; i < grupos.length; i++) {

                const grupo = grupos[i];

                const idEndereco =
                    grupo.id_endereco;

                const tipoGrupo =
                    grupo.tipo;

                /*
                * Primeiro filtra pelo endereço.
                *
                * Depois separa:
                *
                * ESPECIAL = produtos 1 e 3
                * OUTROS   = demais produtos
                */
                const itensFiltrados = itens
                    .filter(item => {

                        if (item.id_endereco != idEndereco) {
                            return false;
                        }

                        const produtoEspecial =
                            produtosEspeciais.includes(
                                Number(item.id_produto)
                            );

                        if (tipoGrupo == 'ESPECIAL') {
                            return produtoEspecial;
                        }

                        return !produtoEspecial;
                    });

                let nomeUnidadePosto = null;
                let cnpjUnidadePosto = null;

                itensFiltrados.forEach(item => {

                    if (item.cnpj_posto) {

                        nomeUnidadePosto =
                            item.cnpj_posto
                                ? (item.cnpj_posto.split('|')[0] || '').trim()
                                : null;

                        cnpjUnidadePosto =
                            item.cnpj_posto
                                ? (item.cnpj_posto.split('|')[1] || '').trim()
                                : null;
                    }
                });

                let registroEnviar = {
                    ...registro,

                    posicao: i,

                    unidade_nome:
                        nomeUnidadePosto ||
                        (unidade ? unidade.nome : null),

                    unidade_cnpj:
                        cnpjUnidadePosto ||
                        (unidade ? unidade.cnpj : null),

                    unidade_ie:
                        cnpjUnidadePosto
                            ? ''
                            : (unidade ? unidade.ie : null),

                    unidade_endereco:
                        cnpjUnidadePosto
                            ? ''
                            : (unidade ? unidade.endereco : null),

                    data_pedido:
                        registro.data_pedido
                            ? DateFormat.formatarDataSqlParaTela(
                                registro.data_pedido
                            )
                            : DateFormat.formatarDataSqlParaTela(
                                DateFormat.getDataAtual()
                            ),

                    nome_usuario_inclusao:
                        registro.nome_usuario_inclusao ||
                        getState().auth.usuario.nome,

                    itens: itensFiltrados.map(item => {

                        let cliente =
                            getState().pedido.listaCliente
                                .filter(itemCliente =>
                                    item.id_cliente == itemCliente.id
                                )[0];

                        let endereco =
                            getState().pedido.listaEndereco
                                .filter(itemEndereco =>
                                    item.id_endereco == itemEndereco.id
                                )[0];

                        let produto =
                            getState().pedido.listaProduto
                                .filter(itemProduto =>
                                    item.id_produto == itemProduto.id
                                )[0];

                        let pedidoPrazo =
                            getState().pedidoPrazo.listaSelect
                                .filter(itemPrazo =>
                                    item.id_prazo == itemPrazo.id
                                )[0];

                        return {
                            ...item,
                            nome_cliente: cliente ? cliente.valor : '',
                            nome_endereco: endereco ? endereco.valor : '',
                            nome_produto: produto ? produto.valor : '',
                            prazo: pedidoPrazo ? pedidoPrazo.nome : item.prazo
                        };
                    })
                };

                axios.post(
                    `${consts.API_URL}/pedido/imprimir`,
                    registroEnviar
                )
                .then(resp => {

                    window.open(
                        `${consts.URL}/${resp.data}`,
                        '_blank'
                    );

                })
                .catch(e => {

                    setErroAPI(e);

                });
            }
        }
    };
}

export function imprimirNovo(registro, agrupar = false, idItem) {
    return (dispatch, getState) => {

        let unidade = [
            { id : 1, nome: 'ÁGUA BOA', cnpj: '15.024.193/0007-83', ie: '13.880.354-4', endereco: 'Av. Industrial, Nº 66, Bairro Industrial I \n Água Boa / MT - CEP: 78635-000' },
            { id : 3, nome: 'BARRA DO GARÇAS', cnpj: '15.024.193/0005-11', ie: '13.708.774-8', endereco: 'Rua 10 0 Quadraind 1/3 Lote 1, Distrito Industrial \n Barra do Garças / MT - CEP 78605-778' },
            { id : 9, nome: 'PORTO ALEGRE DO NORTE', cnpj: '15.024.193/0006-00', ie: '13.880.368-4', endereco: 'Av. Dionel Martins de Almeida, SN, Zona Rural \n Porto Alegre do Norte / MT - CEP 78655-000' },
            { id : 60, nome: 'RIO VERDE (SERTÃO)', cnpj: '01.543.070/0001-59', ie: '10.292.576-3', endereco: 'AV JACOB OLIVAR ALIEV (ANTIGA GLEBA 10), SN - QUADRAGLEB 09 LOTE LT B - ZONA INDUSTRIAL\n Rio Verde / DO - CEP 75901-970' }
        ].filter(item => item.id == registro.id_unidade)[0];

        const itens = registro.itens || [];
        const produtosEspeciais = [1, 3];

        const itemSelecionado = itens.find(
            item => (item.id || item.idAux) == idItem
        );

        if (!itemSelecionado) {
            return;
        }

        const itemSelecionadoEspecial =
            produtosEspeciais.includes(
                Number(itemSelecionado.id_produto)
            );

        if (agrupar) {

            const idCliente =
                itemSelecionado.id_cliente;

            const itensFiltrados =
                itens.filter(item => {

                    if (item.id_cliente != idCliente) {
                        return false;
                    }

                    const produtoEspecial =
                        produtosEspeciais.includes(
                            Number(item.id_produto)
                        );

                    if (itemSelecionadoEspecial) {
                        return produtoEspecial;
                    }

                    return !produtoEspecial;
                });

            let nomeUnidadePosto = null;
            let cnpjUnidadePosto = null;

            itensFiltrados.forEach(item => {

                if (item.cnpj_posto) {

                    nomeUnidadePosto =
                        item.cnpj_posto
                            ? (item.cnpj_posto.split('|')[0] || '').trim()
                            : null;

                    cnpjUnidadePosto =
                        item.cnpj_posto
                            ? (item.cnpj_posto.split('|')[1] || '').trim()
                            : null;
                }
            });

            let registroEnviar = {
                ...registro,

                posicao: 0,

                unidade_nome:
                    nomeUnidadePosto ||
                    (unidade ? unidade.nome : null),

                unidade_cnpj:
                    cnpjUnidadePosto ||
                    (unidade ? unidade.cnpj : null),

                unidade_ie:
                    cnpjUnidadePosto
                        ? ''
                        : (unidade ? unidade.ie : null),

                unidade_endereco:
                    cnpjUnidadePosto
                        ? ''
                        : (unidade ? unidade.endereco : null),

                data_pedido:
                    registro.data_pedido
                        ? DateFormat.formatarDataSqlParaTela(
                            registro.data_pedido
                        )
                        : DateFormat.formatarDataSqlParaTela(
                            DateFormat.getDataAtual()
                        ),

                nome_usuario_inclusao:
                    registro.nome_usuario_inclusao ||
                    getState().auth.usuario.nome,

                itens:
                    itensFiltrados.map(item => {

                        let cliente =
                            getState().pedido.listaCliente
                                .filter(itemCliente =>
                                    item.id_cliente == itemCliente.id
                                )[0];

                        let endereco =
                            getState().pedido.listaEndereco
                                .filter(itemEndereco =>
                                    item.id_endereco == itemEndereco.id
                                )[0];

                        let produto =
                            getState().pedido.listaProduto
                                .filter(itemProduto =>
                                    item.id_produto == itemProduto.id
                                )[0];
                        
                        let pedidoPrazo =
                            getState().pedidoPrazo.listaSelect
                                .filter(itemPrazo =>
                                    item.id_prazo == itemPrazo.id
                                )[0];

                        return {
                            ...item,
                            nome_cliente: cliente ? cliente.valor : '',
                            nome_endereco: endereco ? endereco.valor : '',
                            nome_produto: produto ? produto.valor : '',
                            prazo: pedidoPrazo ? pedidoPrazo.nome : item.prazo
                        };
                    })
            };

            axios.post(
                `${consts.API_URL}/pedido/imprimir`,
                registroEnviar
            ).then(resp => {

                window.open(
                    `${consts.URL}/${resp.data}`,
                    '_blank'
                );

            }).catch(e => {

                setErroAPI(e);
            });

        } else {

            let nomeUnidadePosto = null;
            let cnpjUnidadePosto = null;

            if (itemSelecionado.cnpj_posto) {

                nomeUnidadePosto =
                    itemSelecionado.cnpj_posto
                        ? (
                            itemSelecionado.cnpj_posto
                                .split('|')[0] || ''
                        ).trim()
                        : null;

                cnpjUnidadePosto =
                    itemSelecionado.cnpj_posto
                        ? (
                            itemSelecionado.cnpj_posto
                                .split('|')[1] || ''
                        ).trim()
                        : null;
            }

            let registroEnviar = {
                ...registro,

                posicao: 0,

                unidade_nome:
                    nomeUnidadePosto ||
                    (unidade ? unidade.nome : null),

                unidade_cnpj:
                    cnpjUnidadePosto ||
                    (unidade ? unidade.cnpj : null),

                unidade_ie:
                    cnpjUnidadePosto
                        ? ''
                        : (unidade ? unidade.ie : null),

                unidade_endereco:
                    cnpjUnidadePosto
                        ? ''
                        : (unidade ? unidade.endereco : null),

                data_pedido:
                    registro.data_pedido
                        ? DateFormat.formatarDataSqlParaTela(
                            registro.data_pedido
                        )
                        : DateFormat.formatarDataSqlParaTela(
                            DateFormat.getDataAtual()
                        ),

                nome_usuario_inclusao:
                    registro.nome_usuario_inclusao ||
                    getState().auth.usuario.nome,

                itens:
                    [itemSelecionado].map(item => {

                        let cliente =
                            getState().pedido.listaCliente
                                .filter(itemCliente =>
                                    item.id_cliente == itemCliente.id
                                )[0];

                        let endereco =
                            getState().pedido.listaEndereco
                                .filter(itemEndereco =>
                                    item.id_endereco == itemEndereco.id
                                )[0];

                        let produto =
                            getState().pedido.listaProduto
                                .filter(itemProduto =>
                                    item.id_produto == itemProduto.id
                                )[0];

                        let pedidoPrazo =
                            getState().pedidoPrazo.listaSelect
                                .filter(itemPrazo =>
                                    item.id_prazo == itemPrazo.id
                                )[0];

                        return {
                            ...item,
                            nome_cliente: cliente ? cliente.valor : '',
                            nome_endereco: endereco ? endereco.valor : '',
                            nome_produto: produto ? produto.valor : '',
                            prazo: pedidoPrazo ? pedidoPrazo.nome : item.prazo
                        };
                    })
            };

            axios.post(
                `${consts.API_URL}/pedido/imprimir`,
                registroEnviar
            ).then(resp => {

                window.open(
                    `${consts.URL}/${resp.data}`,
                    '_blank'
                );

            }).catch(e => {

                setErroAPI(e);
            });
        }
    };
}

export function getListaDistribuidora() {
    const request = axios.get(`${consts.API_URL}/distribuidora/listarSelect`);
    return {
        type: 'PEDIDO_DISTRIBUIDORA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCustoPrazo() {
    const request = axios.get(`${consts.API_URL}/custoPrazo`);
    return {
        type: 'PEDIDO_CUSTO_PRAZO_SELECT_LISTADO',
        payload: request
    };
}


export function getListaPoliticaPreco() {
    const request = axios.get(`${consts.API_URL}/politicaPreco/listarUltimaPolitica`);
    return {
        type: 'PEDIDO_POLITICA_PRECO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'PEDIDO_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'PEDIDO_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'PEDIDO_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCliente() {
    const request = axios.get(`${consts.API_URL}/cliente/listarSelect`);
    return {
        type: 'PEDIDO_CLIENTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaEndereco() {
    const request = axios.get(`${consts.API_URL}/endereco/listarSelect`);
    return {
        type: 'PEDIDO_ENDERECO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect?todos=true`);
    return {
        type: 'PEDIDO_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuario() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
    return {
        type: 'PEDIDO_USUARIO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaPedidoTipo() {
    const request = axios.get(`${consts.API_URL}/pedidoTipo/listarSelect`);
    return {
        type: 'PEDIDO_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaPedidoFrete() {
    const request = axios.get(`${consts.API_URL}/pedidoFrete/listarSelect`);
    return {
        type: 'PEDIDO_FRETE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaPedidoCnpj() {
    const request = axios.get(`${consts.API_URL}/pedidoCnpj/listarSelect`);
    return {
        type: 'PEDIDO_CNPJ_SELECT_LISTADO',
        payload: request
    };
}

export function gerarOrcamento(registro) {

	return (dispatch, getState) => {

		axios.post(`${consts.API_URL}/pedido/imprimirOrcamento`, {
            ...registro,
            data_pedido: DateFormat.formatarDataSqlParaTela(registro.data_pedido),
            quantidade: FormatUtils.formatarValorTela(registro.quantidade, 2)
        })
		.then(resp => {
			window.open(`${consts.URL}/${resp.data}`, '_blank');
		}).catch(ex => {
			console.log(ex);
		});

	}
}

export function verificaEstoqueManual() {
 
    return (dispatch, getState) => {
        axios.get(`${consts.API_URL}/estoqueManual/verificaEstoqueManual`).then(resp => {
            dispatch({
                type: 'PEDIDO_ESTOQUE_MANUAL_LANCADO',
                payload: resp.data || false
            });
        }).catch(e => {
            setErroAPI(e);
        });
    }
}

export function verificaAbastecida() {
 
    return (dispatch, getState) => {
        axios.get(`${consts.API_URL}/saida/verificaLancada`).then(resp => {
            dispatch({
                type: 'PEDIDO_ABASTECIDA_LANCADA',
                payload: resp.data || false
            });
        }).catch(e => {
            setErroAPI(e);
        });
    }
}

export function getListaPedidoMotorista() {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?id_motorista=${getState().auth.usuario.id_motorista}`).then(resp => {
            dispatch({
                type: 'PEDIDO_MOTORISTA_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaComprovacao() {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?comprovacao=true`).then(resp => {
            dispatch({
                type: 'PEDIDO_COMPROVACAO_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function getListaPedidoBase() {

    return (dispatch, getState) => {
        dispatch(setAguardando(true));
        axios.get(`${consts.API_URL}/pedido?base=true`).then(resp => {
            dispatch({
                type: 'PEDIDO_BASE_LISTADO',
                payload: resp
            });
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    }
}

export function alterarViagemMotorista(registro, evento) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedido/alterarViagemMotorista`, {
			...registro,
            km_inicio_viagem: FormatUtils.formatarValorBanco(registro.km_inicio_viagem, 0),
            km_fim_viagem: FormatUtils.formatarValorBanco(registro.km_fim_viagem, 0)
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaPedidoMotorista());
            dispatch(setAguardando(false));
            evento();
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function alterarViagemKm(registro, evento) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedido/alterarViagemMotorista`, {
			...registro,
            km_inicio_viagem: FormatUtils.formatarValorBanco(registro.km_inicio_viagem, 0),
            km_fim_viagem: FormatUtils.formatarValorBanco(registro.km_fim_viagem, 0)
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(setAguardando(false));
            evento();
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function alterarComprovanteMotorista(registro, evento) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedidoItem/comprovanteMotorista`, {
			...registro,
            id_usuario_comprovante: getState().auth.usuario.id
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(setAguardando(false));
            dispatch(getListaPedidoMotorista());
            evento();
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function alterarImagemNfe(registro, evento) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedidoItem/comprovanteMotorista`, {
			...registro,
            apenas_nfe: true,
            id_usuario_comprovante: getState().auth.usuario.id
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(setAguardando(false));
            dispatch(getListaComprovacao());
            evento(resp.data.imagem_nfe);
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function alterarImagemChecklist(registro, evento) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedidoItem/comprovanteMotorista`, {
			...registro,
            apenas_checklist: true,
            id_usuario_comprovante: getState().auth.usuario.id
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(setAguardando(false));
            dispatch(getListaComprovacao());
            evento(resp.data.imagem_checklist);
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function alterarComprovacao(registro, evento) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedido/alterarComprovacao`, {
			...registro,
            km_inicio_viagem: FormatUtils.formatarValorBanco(registro.km_inicio_viagem),
            km_fim_viagem: FormatUtils.formatarValorBanco(registro.km_fim_viagem),
            id_usuario_comprovacao: getState().auth.usuario.id
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaComprovacao());
            dispatch(setAguardando(false));
            evento();
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function alterarCarregamentoBase(registro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/pedido/alterarBase`, {
			...registro
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaPedidoBase());
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function abrirPedido(endereco, simulador) {
    return (dispatch, getState) => {

        window.location = '#/pedido';

        const idInterval = setInterval(() => {
            if (getState().pedido.listaCliente.length && getState().pedido.listaEndereco.length) {
                dispatch(setAguardando(false));
                dispatch(initForm({
                    id_tipo: 2,
                    simulador: simulador,
                    itens: [{
                        idAux: new Date().getTime(), 
                        ativo: true, 
                        ordem: 1,
                        id_cliente: endereco.id_cliente,
                        id_endereco: endereco.id

                    }]
                }));
                dispatch(setModoTela('cadastro', {}));

                clearInterval(idInterval);
            } else {
                dispatch(setAguardando(true));
            }
        }, 1000);
		
    };
}

export function getListaNotificacaoPedido(registro) {

    return async (dispatch, getState) => {

        dispatch(setAguardando(true));

        dispatch({
            type: 'PEDIDO_NOTIFICACAO_LISTADO',
            payload: { data: [] }
        });

        let listaRetorno = [];

        let kmAnterior = parseInt(registro.tracking_odometro_inicio);
        for (let i = 0; i < (registro.itens || []).length; i++) {
            const item = (registro.itens || [])[i];

            let itemNotificacao = {
                ...item,
                celular: null,
                status_notificacao_faturado: 'Sem Notificação',
                datahora_notificacao_faturado: null,
                status_notificacao_rota: 'Sem Notificação',
                datahora_notificacao_rota: null,
                status_notificacao_chegada: 'Sem Notificação',
                datahora_notificacao_chegada: null,
                km_rodado: item.tracking_odometro_chegada > 0 && kmAnterior > 0 ? parseInt(item.tracking_odometro_chegada) - kmAnterior : (item.tracking_odometro_chegada > 0 ? 0 : null)
            };

            kmAnterior = item.tracking_odometro_chegada > 0 && kmAnterior > 0 ? parseInt(item.tracking_odometro_chegada) : kmAnterior;

            await axios.get(`${consts.API_URL}/notificacao?id_tipo=1&id_controle=${item.id}&id_operacao=3`).then(resp => {
                if (resp.data && resp.data[0]) {
                    itemNotificacao = {
                        ...itemNotificacao,
                        celular: itemNotificacao.celular,
                        status_notificacao_faturado: resp.data[0].status_retorno == null ? 'Aguardando Envio' : (resp.data[0].status_retorno ? 'Enviado' : 'Não Enviado'),
                        datahora_notificacao_faturado: resp.data[0].datahora_inclusao,
                        retorno_notificacao_faturado: resp.data[0].status_retorno ? 'Enviado' : (itemNotificacao.retorno || 'Não Enviado') 
                    }
                }
            }).catch(e => {
                console.log(e);
            });

            await axios.get(`${consts.API_URL}/notificacao?id_tipo=1&id_controle=${item.id}&id_operacao=1`).then(resp => {
                if (resp.data && resp.data[0]) {
                    itemNotificacao = {
                        ...itemNotificacao,
                        celular: itemNotificacao.celular,
                        status_notificacao_rota: resp.data[0].status_retorno == null ? 'Aguardando Envio' : (resp.data[0].status_retorno ? 'Enviado' : 'Não Enviado'),
                        datahora_notificacao_rota: resp.data[0].datahora_inclusao,
                        retorno_notificacao_rota: resp.data[0].status_retorno ? 'Enviado' : (itemNotificacao.retorno || 'Não Enviado') 
                    }
                }
            }).catch(e => {
                console.log(e);
            });

            await axios.get(`${consts.API_URL}/notificacao?id_tipo=1&id_controle=${item.id}&id_operacao=2`).then(resp => {
                if (resp.data && resp.data[0]) {
                    itemNotificacao = {
                        ...itemNotificacao,
                        celular: itemNotificacao.celular,
                        status_notificacao_chegada: resp.data[0].status_retorno == null ? 'Aguardando Envio' : (resp.data[0].status_retorno ? 'Enviado' : 'Não Enviado'),
                        datahora_notificacao_chegada: resp.data[0].datahora_inclusao,
                        retorno_notificacao_chegada: resp.data[0].status_retorno ? 'Enviado' : (itemNotificacao.retorno || 'Não Enviado')
                    }
                }
            }).catch(e => {
                console.log(e);
            });

            listaRetorno.push(itemNotificacao);
        }

        dispatch({
            type: 'PEDIDO_NOTIFICACAO_LISTADO',
            payload: { data: listaRetorno }
        });
            
        dispatch(setAguardando(false));
    }
}

export function atualizarWhatsAppVenda(registro) {
    return (dispatch, getState) => {
        axios.put(`${consts.API_URL}/endereco/alterarWhatsappVenda`, {
			...registro,
            id_usuario_alteracao: getState().auth.usuario.id,
		}).then(resp => {
            dispatch(getListaEndereco());
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function getLinkRastreio(idPedido, idEndereco) {

    return (dispatch, getState) => {
        axios.get(`${consts.API_URL}/pedido/gerarIdRastreamento?id_pedido=${idPedido}&id_endereco=${idEndereco}`).then(resp => {
            if (resp.data) {
                window.open(resp.data.link, '_blank');
            }
        }).catch(e => {
            setErroAPI(e);
        });
    }
}

export function getStatusWhatsapp() {

    return (dispatch, getState) => {
        axios.get(`${consts.API_URL}/whatsapp/zapi/status`).then(resp => {
            dispatch({
                type: 'PEDIDO_STATUS_WHATSAPP_LISTADO',
                payload: resp.data
            });
        }).catch(e => {
            setErroAPI(e);
        });
    }
}

export function getLimitePetroshow(idsClientes = []) {

    return (dispatch, getState) => {
        if (idsClientes.length) {
            axios.get(`${consts.API_URL}/cliente/petro/limite?${idsClientes.map(id => `ids_clientes[]=${id}`).join('&')}`).then(resp => {
                dispatch({
                    type: 'PEDIDO_LIMITE_PETROSHOW_LISTADO',
                    payload: resp
                });
            }).catch(e => {
                setErroAPI(e);
            });
        } else {
            dispatch({
                type: 'PEDIDO_LIMITE_PETROSHOW_LISTADO',
                payload: { data: [] }
            });
        }
    }
}